
import { Component, Vue } from 'vue-property-decorator';
import { Module1Module } from '@/store/modules/module1';

@Component
export default class Nav extends Vue {
  showModal = false;
  allowModalToBeClosed = false;
  modalTitle = 'Please Wait';
  modalParagraph = 'Transaction pending...'
  darkMode = false;

  get isDev () : boolean {
    return Module1Module.isDev;
  }

  get net () : string {
    return Module1Module.net;
  }

  // could just be inside of <Nav>
  get avatarImage () : string {
    return this.$store.state.module1.avatarImage;
  }

  get contractAddress () : string {
    return Module1Module.contractAddress;
  }

  get account () : string {
    return this.$store.state.module1.account;
  }

  get username () : string | undefined {
    return this.$store.state.module1.account ? this.$store.state.module1.account.address : undefined;
  }

  created () : void {
    const darkMode = localStorage.getItem('xtznftswap-dark-mode');
    if (darkMode === null || darkMode === undefined || darkMode === 'true') {
      this.appendDarkModeScript();
    }
  }

  changeRoutePropose () : void {
    try {
      this.$router.push({
        name: 'Propose',
        path: '/propose'
      });
    } catch (error) {
      console.warn(error);
    }
  }

  possiblyCloseModal () : void {
    if (this.allowModalToBeClosed) {
      this.showModal = false;
      this.allowModalToBeClosed = false;
    }
  }

  toggleDarkMode () : void {
    const already = document.querySelector('#dark-mode-styles');

    if (already) {
      already.remove();
      localStorage.removeItem('xtznftswap-dark-mode');
      this.darkMode = false;
      return;
    }

    this.appendDarkModeScript();
  }

  appendDarkModeScript () : void {
    // append dark-mode styles to root level so that
    // tailwind overrides work but also dont become too deeply nested.
    // when you do overrides within a cusom class like `.dark` they become
    // too high specificity and things like hovers start to breakdown
    var element = document.createElement('link');
    element.setAttribute('rel', 'stylesheet');
    element.setAttribute('id', 'dark-mode-styles');
    element.setAttribute('type', 'text/css');
    element.setAttribute('href', 'dark.css');
    document.getElementsByTagName('head')[0].appendChild(element);
    localStorage.setItem('xtznftswap-dark-mode', 'true');
    this.darkMode = true;
  }

  async login () : Promise<void> {
    try {
      this.showModal = true;
      this.modalTitle = 'Logging In';
      this.modalParagraph = 'Please wait while we log you in using your tezos wallet and pull your latest trade data...';

      // request login access
      await Module1Module.beaconWalletInstance.requestPermissions({
        network: {
          type: this.net as any
        }
      });

      const rpc = `https://${this.net}.smartpy.io`;
      await Module1Module.SetToolkit(rpc);
      await Module1Module.SetAccount();

      const xtznftswapContract = await Module1Module.tezosToolkitInstance.contract.at(
        this.contractAddress
      );
      Module1Module.SetSwapContract(xtznftswapContract);

      await Module1Module.FetchAllContractTradeData();

      this.showModal = false;
      this.$router.push({
        name: 'Propose',
        path: '/propose'
      });
    } catch (error: any) {
      this.showModal = true;
      this.modalTitle = '<span class="text-red-600">Error: ' + error.title + '</span>';
      this.modalParagraph = error.description;
      this.allowModalToBeClosed = true;
      console.warn(error);
    }
  }

  async logout () : Promise<void> {
    try {
      this.showModal = true;
      this.modalTitle = 'Logging out...';
      this.modalParagraph = 'Please wait while we log you out.';

      await Module1Module.UnsetAccount();

      this.showModal = false;

      this.$router.push({
        path: '/login'
      });
    } catch (error: any) {
      this.showModal = true;
      this.modalTitle = '<span class="text-red-600">Error: ' + error.title + '</span>';
      this.modalParagraph = error.description;
      this.allowModalToBeClosed = true;
    }
  }
}
